export interface MangaCategory {
  slug: string;
  name: string;
  en: string;
  icon: string;
  description: string;
}

export interface MangaWork {
  id: string;
  title: string;
  categorySlug: string;
  categoryName: string;
  tags: string[];
  author: string;
  artist: string;
  status: "连载中" | "已完结";
  episodes: number;
  rating: number;
  views: string;
  intro: string;
  longIntro: string;
  cover: string;
  latestChapter: string;
  featured?: boolean;
  trending?: boolean;
}

export const categories: MangaCategory[] = [
  {
    slug: "xuejing",
    name: "雪景漫画",
    en: "Snowscape",
    icon: "ri-snowy-line",
    description: "以纯白雪景为舞台的治愈与浪漫，凛冽中藏着温暖人心的故事。",
  },
  {
    slug: "dongri",
    name: "冬日漫画",
    en: "Winter Days",
    icon: "ri-fire-line",
    description: "围炉、热茶、初雪与久别重逢，属于冬日的日常与温度。",
  },
  {
    slug: "xueguo",
    name: "雪国漫画",
    en: "Snow Country",
    icon: "ri-landscape-line",
    description: "被大雪覆盖的极北之地，荒芜与守望交织的雪国群像。",
  },
  {
    slug: "dongwuyu",
    name: "冬物语",
    en: "Winter Tales",
    icon: "ri-moon-clear-line",
    description: "发生在漫长冬夜里的幻想物语，月光、星屑与未说出口的心事。",
  },
  {
    slug: "bingxue",
    name: "冰雪漫画",
    en: "Ice & Frost",
    icon: "ri-snowflake-line",
    description: "冰晶、霜花与极寒魔法，充满奇观与冒险的冰雪世界。",
  },
  {
    slug: "xuenv",
    name: "雪女漫画",
    en: "Snow Spirit",
    icon: "ri-ghost-line",
    description: "雪女传说与幽微人性，冷艳外表下深藏的温柔与执念。",
  },
];

export const mangaWorks: MangaWork[] = [
  {
    id: "letter-from-snow-country",
    title: "雪国的来信",
    categorySlug: "xuejing",
    categoryName: "雪景漫画",
    tags: ["治愈", "爱情", "书信"],
    author: "林野",
    artist: "初雪绘",
    status: "连载中",
    episodes: 38,
    rating: 9.2,
    views: "184.6万",
    intro: "每年冬天，车站邮筒里总会多出一封没有署名的信，收信人，是十年前离开雪国的她。",
    longIntro:
      "北方小镇的冬天漫长而安静。十年前的一个暴雪夜，少女铃枝随父母搬离雪国，留下了一封未寄出的信。十年后，她因工作重返故乡，却发现每年初雪时，那封没能寄出的信，都被同一个人原封不动地放回邮筒。写信的人究竟是谁？当小镇的雪再次落下，一段被大雪掩埋多年的心事，也终于要被翻开。",
    cover: "https://readdy.ai/api/search-image?query=soft%20painterly%20anime%20illustration%20manga%20cover%2C%20a%20young%20woman%20in%20a%20bright%20red%20wool%20scarf%20holding%20a%20sealed%20letter%20standing%20on%20a%20snowy%20railway%20platform%20at%20night%2C%20gentle%20snowfall%2C%20warm%20amber%20station%20lamp%20glow%20against%20cool%20blue%20snow%20tones%2C%20cinematic%20ethereal%20atmosphere%2C%20highly%20detailed%2C%20emotional%20storybook%20mood&width=480&height=640&seq=manga-cover-01&orientation=portrait",
    latestChapter: "第 38 话 · 初雪来信",
    featured: true,
    trending: true,
  },
  {
    id: "midnight-train",
    title: "寒夜列车",
    categorySlug: "dongri",
    categoryName: "冬日漫画",
    tags: ["悬疑", "惊悚", "幻想"],
    author: "北岸",
    artist: "霜夜作",
    status: "连载中",
    episodes: 27,
    rating: 8.8,
    views: "96.3万",
    intro: "每逢大雪封路，凌晨三点整，总会有一列不该存在的列车缓缓驶入站台。",
    longIntro:
      "小城唯一的一趟末班列车，在每年最深寒的夜里会被大雪困住。可每到凌晨三点，车窗外仍会驶过一列灯火通明的旧式列车——它不在任何时刻表上。列车员阿海在一次误乘后，发现车厢里的乘客都来自不同年代的失踪者。他们要前往的，究竟是终点站，还是一个被大雪遗忘的地方？",
    cover: "https://readdy.ai/api/search-image?query=dark%20cinematic%20anime%20illustration%20manga%20cover%2C%20a%20lonely%20passenger%20gazing%20out%20the%20frosted%20window%20of%20a%20vintage%20train%20racing%20through%20a%20midnight%20blizzard%2C%20cold%20blue-white%20snow%20storm%20outside%2C%20dim%20warm%20interior%20lamp%20inside%2C%20mysterious%20and%20ominous%20atmosphere%2C%20moody%20lighting%2C%20highly%20detailed%20painterly%20style&width=480&height=640&seq=manga-cover-02&orientation=portrait",
    latestChapter: "第 27 话 · 无人站台",
    trending: true,
  },
  {
    id: "rime-town-story",
    title: "雾凇镇物语",
    categorySlug: "xueguo",
    categoryName: "雪国漫画",
    tags: ["日常", "温情", "小镇"],
    author: "牧川",
    artist: "冬青",
    status: "已完结",
    episodes: 52,
    rating: 9.0,
    views: "210.4万",
    intro: "被雾凇环绕的边境小镇，一群普通人的四季与无数个被雪记住的瞬间。",
    longIntro:
      "雾凇镇坐落在群山深处，一到冬天，整座小镇便被挂满冰晶的树枝包裹，像一座沉睡在水晶里的王国。故事跟随镇上唯一一家茶屋的老板娘，记录下理发师、邮差、列车员、少年少女们的琐碎日常。大雪会覆盖一切，却总有一些温暖，比冬天活得更久。",
    cover: "https://readdy.ai/api/search-image?query=gentle%20pastel%20anime%20illustration%20manga%20cover%2C%20a%20quaint%20snowy%20village%20draped%20in%20rime%20frost%20with%20glistening%20ice%20crystals%20on%20bare%20trees%2C%20morning%20mist%2C%20cozy%20chimney%20smoke%20rising%2C%20warm%20windows%20glowing%20amber%20against%20soft%20cool%20blue%20snow%2C%20peaceful%20heartwarming%20atmosphere%2C%20highly%20detailed%20painterly%20storybook%20style&width=480&height=640&seq=manga-cover-03&orientation=portrait",
    latestChapter: "第 52 话 · 春雪",
    featured: true,
  },
  {
    id: "snow-woman-long-night",
    title: "雪女的长夜",
    categorySlug: "xuenv",
    categoryName: "雪女漫画",
    tags: ["奇幻", "宿命", "爱情"],
    author: "夜雾",
    artist: "绯雪",
    status: "连载中",
    episodes: 31,
    rating: 9.1,
    views: "153.8万",
    intro: "传说被雪女拥抱的人会化作寒冰，可他却在这漫长冬夜里，一次次走向她的森林。",
    longIntro:
      "北国的山林中流传着雪女的传说——在暴雪夜迷路的人，若被雪女拥入怀中，便会在温暖中沉沉睡去，再也不会醒来。猎户之子白曜，却因十年前一场事故，与雪女订下了无法解除的约定。每个雪夜他都要踏入那片冰封的森林，而雪女的长夜，也因这个人类少年，第一次泛起了温度。",
    cover: "https://readdy.ai/api/search-image?query=ethereal%20fantasy%20anime%20illustration%20manga%20cover%2C%20a%20pale%20beautiful%20snow%20spirit%20woman%20with%20flowing%20silver-white%20hair%20and%20icy%20faintly%20glowing%20eyes%20standing%20in%20a%20frozen%20forest%20under%20cold%20moonlight%2C%20snow%20particles%20floating%2C%20melancholic%20romantic%20mood%2C%20cool%20blue%20and%20soft%20lilac%20tones%20with%20subtle%20warm%20highlights%2C%20highly%20detailed%20painterly%20style&width=480&height=640&seq=manga-cover-04&orientation=portrait",
    latestChapter: "第 31 话 · 约定",
    featured: true,
    trending: true,
  },
  {
    id: "frozen-forest",
    title: "冰封之森",
    categorySlug: "bingxue",
    categoryName: "冰雪漫画",
    tags: ["冒险", "魔法", "奇幻"],
    author: "朔风",
    artist: "琉璃绘",
    status: "已完结",
    episodes: 45,
    rating: 8.7,
    views: "121.0万",
    intro: "整座森林被一夜之间冰封，唯有少女和一只小狐，还保有融化的心跳。",
    longIntro:
      "当末日的寒潮席卷大陆，曾经生机盎然的精灵之森在一夜之间化作永恒的冰雕。存活下来的，只有不识字的采药少女阿芽，和一只会说人话、却总是嘴硬的小白狐。她们要循着森林尽头那道若隐若现的暖光，找回能够让春天重新到来的最后一块火种。",
    cover: "https://readdy.ai/api/search-image?query=vibrant%20fantasy%20anime%20illustration%20manga%20cover%2C%20a%20frozen%20enchanted%20forest%20of%20crystalline%20ice%20trees%2C%20a%20small%20white%20fox%20and%20a%20young%20girl%20with%20a%20lantern%20trekking%20through%20gleaming%20snow%2C%20magical%20ice%20sparkles%2C%20cool%20icy%20blues%20with%20a%20warm%20golden%20lantern%20glow%2C%20adventurous%20wonder%20filled%20atmosphere%2C%20highly%20detailed%20painterly%20style&width=480&height=640&seq=manga-cover-05&orientation=portrait",
    latestChapter: "第 45 话 · 春回大地",
  },
  {
    id: "winter-tale-first-snow",
    title: "冬物语·初雪",
    categorySlug: "dongwuyu",
    categoryName: "冬物语",
    tags: ["爱情", "青春", "治愈"],
    author: "苏离",
    artist: "浅川",
    status: "连载中",
    episodes: 19,
    rating: 9.0,
    views: "78.9万",
    intro: "他们约定，若能在初雪前说出那句告白，冬天就会变得不一样。",
    longIntro:
      "十七岁那年，少年在林间向她承诺：若我们能在今年第一场雪落下之前，把彼此的心意说出口，那么漫长的冬天也会变得值得。可是雪从不等人，少年的话也从未说尽。多年后的初雪夜，当两人在同一个路灯下重逢，那场迟到了整个青春的告白，才终于落进了雪里。",
    cover: "https://readdy.ai/api/search-image?query=romantic%20soft%20anime%20illustration%20manga%20cover%2C%20a%20young%20couple%20standing%20beneath%20a%20streetlamp%20during%20the%20first%20snowfall%20of%20winter%2C%20large%20gentle%20snowflakes%20falling%2C%20warm%20golden%20lantern%20light%20wrapping%20them%20against%20the%20cool%20blue%20snowy%20night%2C%20tender%20yearning%20atmosphere%2C%20highly%20detailed%20painterly%20storybook%20style&width=480&height=640&seq=manga-cover-06&orientation=portrait",
    latestChapter: "第 19 话 · 迟到的告白",
    trending: true,
  },
  {
    id: "hearth-and-moonlight",
    title: "暖炉与月光",
    categorySlug: "dongri",
    categoryName: "冬日漫画",
    tags: ["日常", "治愈", "猫"],
    author: "暖茶",
    artist: "云雀",
    status: "已完结",
    episodes: 36,
    rating: 8.9,
    views: "167.2万",
    intro: "在暖气坏掉的那年冬天，一个人的公寓里，搬来了一只沉默的猫。",
    longIntro:
      "程序员的深夜生活单调到能数清窗外每片雪花的形状。直到那个暖气坏掉的寒冬，一只浑身湿透的橘猫从窗台闯了进来，从此他的公寓多了一位不爱说话的室友。一人一猫在漫长冬夜里互相取暖，月光的清辉下，两颗孤独的心渐渐靠近。",
    cover: "https://readdy.ai/api/search-image?query=cozy%20warm%20anime%20illustration%20manga%20cover%2C%20an%20interior%20scene%20of%20a%20small%20apartment%20with%20a%20crackling%20fireplace%2C%20an%20orange%20cat%20curled%20on%20a%20wool%20blanket%20near%20a%20window%2C%20cool%20moonlight%20and%20falling%20snow%20visible%20outside%2C%20warm%20amber%20firelight%20inside%2C%20cozy%20peaceful%20heartwarming%20atmosphere%2C%20highly%20detailed%20painterly%20style&width=480&height=640&seq=manga-cover-07&orientation=portrait",
    latestChapter: "第 36 话 · 春天的暖炉",
    featured: true,
  },
  {
    id: "white-fox-hunter",
    title: "白狐与猎人",
    categorySlug: "xuejing",
    categoryName: "雪景漫画",
    tags: ["奇幻", "羁绊", "冒险"],
    author: "断崖",
    artist: "松间",
    status: "连载中",
    episodes: 24,
    rating: 8.6,
    views: "64.5万",
    intro: "猎人的箭射向雪原的白狐，却在扣动弓弦的瞬间，听到了它开口说话的声音。",
    longIntro:
      "深居雪原的少年猎人奉命猎杀一头传说中化作白狐的山神，可当他真正举起弓的那一刻，白狐却口吐人言，请求他带自己穿过暴风雪去往南方的暖城。一段被雪山见证的同行之路就此开始——猎人守护的不再是猎物，而是一段跨越人与妖界限的承诺。",
    cover: "https://readdy.ai/api/search-image?query=atmospheric%20anime%20illustration%20manga%20cover%2C%20a%20snowy%20pine%20forest%20with%20a%20white%20nine-tailed%20fox%20and%20a%20young%20hunter%20in%20dark%20cloak%20standing%20face%20to%20face%20in%20falling%20snow%2C%20mystical%20cool%20blue%20tones%20with%20warm%20faint%20light%20through%20the%20trees%2C%20bond%20and%20wonder%20atmosphere%2C%20highly%20detailed%20painterly%20style&width=480&height=640&seq=manga-cover-08&orientation=portrait",
    latestChapter: "第 24 话 · 南方的雪",
  },
  {
    id: "northern-lighthouse",
    title: "极北灯塔",
    categorySlug: "xueguo",
    categoryName: "雪国漫画",
    tags: ["孤岛", "悬疑", "守望"],
    author: "白涛",
    artist: "海雾",
    status: "已完结",
    episodes: 40,
    rating: 8.8,
    views: "89.7万",
    intro: "极北之地的孤岛灯塔上，守塔人守着的不只是灯，还有一个失踪了三十年的名字。",
    longIntro:
      "在连海面都会结冰的极北尽头，有一座孤独的灯塔。新任守塔人阿砾到任第一夜，便在海浪与暴雪声中，隐约听见有人呼唤他的名字。灯塔的航海日志里，三十年前最后一任守塔人的记录停在某个暴雪夜。那个消失的人，究竟是被大海带走，还是依旧在风雪中守望着归来的船只？",
    cover: "https://readdy.ai/api/search-image?query=dramatic%20cinematic%20anime%20illustration%20manga%20cover%2C%20a%20lighthouse%20standing%20on%20a%20desolate%20arctic%20cliff%20amid%20a%20raging%20snowstorm%20and%20dark%20freezing%20sea%2C%20a%20single%20warm%20beacon%20beam%20cutting%20through%20the%20blizzard%2C%20lone%20figure%20with%20a%20lantern%2C%20moody%20cool%20blue-white%20tones%2C%20lonely%20suspenseful%20atmosphere%2C%20highly%20detailed%20painterly%20style&width=480&height=640&seq=manga-cover-09&orientation=portrait",
    latestChapter: "第 40 话 · 灯还在亮",
  },
  {
    id: "snow-moon-blossom",
    title: "雪月花",
    categorySlug: "dongwuyu",
    categoryName: "冬物语",
    tags: ["古风", "唯美", "爱情"],
    author: "玉阶",
    artist: "寒蝉",
    status: "连载中",
    episodes: 33,
    rating: 9.1,
    views: "142.3万",
    intro: "雪、月、花三姊妹掌管着冬夜的三种情绪，直到一名凡人书生误入她们的梦境。",
    longIntro:
      "传说北国冬夜有三位神明：雪之神掌管苍茫，月之神掌管清冷，花之神掌管易逝。她们以梦境为棋局，守护人间一个个漫长的冬夜。一名失意的书生误闯入这场梦境，竟让掌管冬夜的三位神女，第一次生出了想要守住一个春天的心意。",
    cover: "https://readdy.ai/api/search-image?query=elegant%20classical%20chinese%20style%20anime%20illustration%20manga%20cover%2C%20plum%20blossoms%20blooming%20on%20branches%20laden%20with%20snow%2C%20full%20cold%20moon%20in%20a%20deep%20night%20sky%2C%20a%20scholar%20in%20robe%20gazing%20at%20falling%20petals%20in%20moonlight%2C%20poetic%20refined%20mood%2C%20cool%20silver-blue%20and%20soft%20rose%20accents%2C%20highly%20detailed%20traditional%20painterly%20style&width=480&height=640&seq=manga-cover-10&orientation=portrait",
    latestChapter: "第 33 话 · 梦里春来",
    trending: true,
  },
  {
    id: "frost-flower-shop",
    title: "霜花店",
    categorySlug: "bingxue",
    categoryName: "冰雪漫画",
    tags: ["治愈", "幻想", "美食"],
    author: "拾霜",
    artist: "洛白",
    status: "连载中",
    episodes: 21,
    rating: 8.5,
    views: "51.8万",
    intro: "巷子深处的霜花店只在雪夜营业，卖的是能让人梦见春天的冰点。",
    longIntro:
      "老城区巷子深处，有一家只在雪夜亮灯的甜品店，招牌写着「霜花店」。传闻在这里吃过一份冰点的人，会在当晚梦见已逝的人、错过的季节，或是一整个不曾到来的春天。深夜进店的人们各自带着心事，而店主总能端上刚好适合他们的一碗冬天。",
    cover: "https://readdy.ai/api/search-image?query=whimsical%20cozy%20anime%20illustration%20manga%20cover%2C%20a%20tiny%20shops%20window%20covered%20in%20intricate%20frost%20flowers%20with%20a%20warm%20glowing%20interior%2C%20delicate%20ice%20desserts%20and%20snowflake%20decor%2C%20snow%20falling%20outside%2C%20warm%20amber%20shop%20light%20against%20cool%20icy%20exterior%2C%20magical%20cozy%20atmosphere%2C%20highly%20detailed%20painterly%20style&width=480&height=640&seq=manga-cover-11&orientation=portrait",
    latestChapter: "第 21 话 · 春之冰点",
  },
  {
    id: "snow-woman-summer",
    title: "雪女的盛夏",
    categorySlug: "xuenv",
    categoryName: "雪女漫画",
    tags: ["治愈", "异乡", "成长"],
    author: "南枝",
    artist: "朝露",
    status: "已完结",
    episodes: 44,
    rating: 8.9,
    views: "107.6万",
    intro: "无法留在夏天的雪女，决定在融化之前，去南方看一眼海。",
    longIntro:
      "雪女天生畏热，一旦到了盛夏便会渐渐消散。可自幼被山麓人家收留的雪女小雪，偏偏渴望去看一次从未见过的大海。她带着一个会在夏天融化的承诺出发，沿途结识了形形色色的人，也在旅途尽头明白：有些美好，正因为短暂，才格外珍贵。",
    cover: "https://readdy.ai/api/search-image?query=bittersweet%20anime%20illustration%20manga%20cover%2C%20a%20pale%20snow%20spirit%20girl%20in%20a%20light%20summer%20dress%20standing%20in%20a%20sunlit%20green%20meadow%20near%20a%20distant%20ocean%2C%20sunbeams%20and%20floating%20pollen%2C%20gentle%20sadness%20mixed%20with%20warmth%2C%20soft%20golden%20and%20cool%20white%20tones%2C%20highly%20detailed%20painterly%20style&width=480&height=640&seq=manga-cover-12&orientation=portrait",
    latestChapter: "第 44 话 · 去看海",
  },
];

export const heroBackground =
  "https://readdy.ai/api/search-image?query=cinematic%20wide%20anime%20background%20art%20of%20a%20quiet%20snowy%20village%20at%20night%20under%20a%20star-filled%20sky%2C%20gentle%20falling%20snowflakes%2C%20warm%20amber%20windows%20glowing%20in%20small%20wooden%20houses%2C%20frosted%20trees%20and%20soft%20mountain%20silhouettes%20in%20the%20distance%2C%20moody%20deep%20indigo%20and%20slate%20tones%20with%20warm%20gold%20accents%2C%20ethereal%20dreamy%20atmosphere%2C%20highly%20detailed%20painterly%20style&width=1600&height=900&seq=hero-snow-night&orientation=landscape";